// Optional context for the actions on a code-review findings card — "open in
// code" and "fix this". The implementations live in the host app
// (packages/app/src/context/review-actions.tsx) because they need the file
// tabs, the layout and the composer; this package only needs the slot.
//
// Optional (returns undefined when no provider is mounted) so the card still
// renders in Storybook, tests and the docs site — just without buttons.
import { createContext, useContext, type ParentProps } from "solid-js"

export type ReviewFinding = {
  file: string
  line?: number
  summary: string
  short_summary: string
  failure_scenario: string
  category?: string
  verdict?: string
  outcome?: string
}

export type ReviewActions = {
  /** Reveal `file` in the editor, selecting `line` when it exists. */
  openInCode(input: { file: string; line?: number }): void
  /** Stage a fix request for these findings in the composer. */
  requestFix(findings: ReviewFinding[]): void
}

const ctx = createContext<ReviewActions | undefined>(undefined)

export function ReviewActionsProvider(props: ParentProps<{ actions: ReviewActions }>) {
  return <ctx.Provider value={props.actions}>{props.children}</ctx.Provider>
}

export function useReviewActions(): ReviewActions | undefined {
  return useContext(ctx)
}
